document.addEventListener('DOMContentLoaded', () => {
// Function to handle changes in select elements
function handleSelectChange(event) {
    const selectElement = event.target;
    const previouslySelectedOption = selectElement.querySelector('option[selected]');
    if (previouslySelectedOption) {
        previouslySelectedOption.removeAttribute('selected');
    }
    const newSelectedOption = selectElement.options[selectElement.selectedIndex];
    newSelectedOption.setAttribute('selected', 'selected');
    console.log("Changed selection in", selectElement.name, "to:", newSelectedOption.value.trim());
    updatePriceWithDelay();
}

// Add event listeners to all select elements
document.querySelectorAll('select').forEach(select => {
    select.addEventListener('change', handleSelectChange);
});

// Function to update the price
function updatePrice() {
    const selectedOptions = [];
    
    // Handle variations
    document.querySelectorAll('.variations fieldset').forEach(container => {
        const selectedRadio = container.querySelector('input[type="radio"]:checked');
        if (selectedRadio) {
            selectedOptions.push(selectedRadio.value);
        }
    });

    // Handle globo-swatch-list
    if (selectedOptions.length === 0) { // Only check if no variation was found
        document.querySelectorAll('.globo-swatch-list .swatch--gl input[type="radio"]:checked').forEach(radio => {
            selectedOptions.push(radio.value);
        });
    }

    if (selectedOptions.length > 0) {
        const selectedCombination = selectedOptions.join(' / ');
        console.log("Selected Combination: ", selectedCombination);

        // Look for corresponding li element using data-name
        const priceListItem = document.querySelector(`.globo-swatch-detail-lists-price li[data-name="${selectedCombination}"]`);

        if (priceListItem) {
            const price = priceListItem.getAttribute('data-price');
            const priceElements = document.querySelectorAll('.price ins .amount');

            priceElements.forEach(priceElement => {
                priceElement.innerText = price;
            });

            console.log("Updated Price: ", price);
        } else {
            console.log("Price list item not found for the selected combination.");
        }
    } else {
        console.log("No valid selections made or incomplete selection.");
    }
}


// Add event listeners to radio buttons in both fieldsets and globo swatch lists
document.querySelectorAll('.variations input[type="radio"], .globo-swatch-list .swatch--gl input[type="radio"]').forEach(radio => {
    radio.addEventListener('change', updatePrice);
});

// Initial price update on page load
updatePrice();

// Function to initialize select options
function initializeOptions() {
    document.querySelectorAll('select').forEach(dropdown => {
        const initiallySelectedOption = dropdown.querySelector('option[selected]');
        if (initiallySelectedOption) {
            console.log(`Initially selected option for ${dropdown.name}:`, initiallySelectedOption.value.trim());
        } else {
            console.log(`No option is initially selected for ${dropdown.name}.`);
        }
    });
}

// Delay initialization to ensure elements are loaded
setTimeout(initializeOptions, 2000);

// Function to update the price with a delay
function updatePriceWithDelay() {
    setTimeout(updatePrice, 500);
}

// Call delayed price update function
updatePriceWithDelay();


  //Date functionality starts here 

function calculateShippingDate(orderDateTime, num_days = 2) {
  let shippingDate = new Date(orderDateTime);

  for (let i = 0; i < num_days; i++) {
    shippingDate.setDate(shippingDate.getDate() + 1);
    if (shippingDate.getDay() === 6) {
      shippingDate.setDate(shippingDate.getDate() + 2);
    } else if (shippingDate.getDay() === 0) {
      shippingDate.setDate(shippingDate.getDate() + 1);
    }
  }

  let deliveryStartDate = new Date(shippingDate);
  let deliveryEndDate = new Date(deliveryStartDate);

  for (let i = 0; i < 2; i++) {
    deliveryEndDate.setDate(deliveryEndDate.getDate() + 1);
    if (deliveryEndDate.getDay() === 6) {
      deliveryEndDate.setDate(deliveryEndDate.getDate() + 2);
    } else if (deliveryEndDate.getDay() === 0) {
      deliveryEndDate.setDate(deliveryEndDate.getDate() + 1);
    }
  }

  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const startDay = deliveryStartDate.getDate();
  const endDay = deliveryEndDate.getDate();
  const month = monthNames[deliveryEndDate.getMonth()];
  const year = deliveryEndDate.getFullYear();

  return `${startDay} to ${endDay} ${month}`;
}

function updateDeliveryDate() {
  const productDeliverByElement = document.querySelector(".product-deliverby p");
  if(productDeliverByElement){
      const textContent = productDeliverByElement.textContent;
      const numDaysMatch = textContent.match(/Estimated arrival (\d+) with Free Standard Shipping/);
      
      if (numDaysMatch && numDaysMatch[1]) {
        const num_days = parseInt(numDaysMatch[1], 10);
        const today = new Date();
        const calculatedDate = calculateShippingDate(today, num_days);
        productDeliverByElement.innerHTML = `Estimated arrival <b>${calculatedDate}</b>  with Free Standard Shipping`;
        const productDeliverByContainer = document.querySelector(".product-deliverby");
        productDeliverByContainer.style.display = "block";
      }
  }
}

  updateDeliveryDate();






});











